// @ts-ignore
import MqaToggleDashboardResult from 'generated/Result/SystemManagement/Models/MqaToggleDashboardResult';
// @ts-ignore
import MqaToggleDto from 'generated/Result/SystemManagement/Models/MqaToggleDto';
import {
  GET_MQA_TOGGLES, RESET_MQA_TOGGLES, CREATE_MQA_TOGGLE
} from 'redux/types/mqa_toggle';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface MqaToggleState {
  mqaToggleHistory: MqaToggleDashboardResult,
  mqaToggle: MqaToggleDto
}

const INITIAL_STATE: MqaToggleState = {
  mqaToggleHistory: null,
  mqaToggle: null
};

const mqaToggleReducer = function (
  state: MqaToggleState = INITIAL_STATE,
  action: PayloadAction<any>
): MqaToggleState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;

    case GET_MQA_TOGGLES:
      return { ...state, mqaToggleHistory: action.payload };

    case RESET_MQA_TOGGLES:
      return { ...state, mqaToggleHistory: null };

    case CREATE_MQA_TOGGLE:
      return { ...state, mqaToggle: action.payload };

    default:
      return state;
  }
};

export default mqaToggleReducer;
